import { FC } from 'react'

import {
  ConfigFormTemplate,
  InputSelectControlField
} from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import {
  ActionType,
  actionTypeLabel,
  actionTypeTargetDefinition
} from '../action.types'
import { Config } from './actionPlaceholder.types'

export const ActionPlaceholderNodeConfigForm: FC<ConfigFormProps> = ({
  nodeId
}) => {
  const { nodeData, updateNodeType, definition, validationErrors } =
    useNode<Config>({ nodeId })

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Action">
        <InputSelectControlField
          placeholder="Select action..."
          options={Object.entries(actionTypeLabel).map(([value, label]) => ({
            value,
            label
          }))}
          onChange={actionType => {
            updateNodeType(actionTypeTargetDefinition[actionType as ActionType])
          }}
          validationErrors={validationErrors.actionType}
          data-testid="automations.editor.configForm.action.actionType"
        />
      </ConfigFormTemplate.Row>
    </ConfigFormTemplate>
  )
}
